import React, { Component } from "react";
import { isEmpty, get, cloneDeep } from "lodash";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import { PERMISSION } from "../../../../constants/permission";
import {
  checkTablePermission,
  checkAddPermission,
} from "../../../../utils/route-auth";

import Table from "../../../../components/CustomTable";
import ModalConfirmation from "../../../../components/ModalConfirmation";
import asyncRoute from "../../../../helpers/hoc/asyncRoute";
import routes from "../../../../routes";
import { isTenantAgency } from "../../../../selectors/index";

import {
  optionsData,
  mappedCampaignOptions,
  roStatus,
  mappedStatus,
} from "./constant";
import { Modal } from "semantic-ui-react";
// import Select from '../../../components/FormElements/Select'

// import "";
import Select from "react-select";

import {
  getIoListAllReportAction,
  deleteIoAction,
  getIoEditIdReportAction,
  addIoReportAction,
  roListAction,
  roListNamesAction,
  campaignMappedRoAction,
  downloadRoListAction,
  roStatusUpdateAction,
  deleleMappedWithCampaignAction,
  getCountUnMappedCampaignAction,
  getCampaignCustomAction,
  postCampaignRoListAction,
} from "../../../../actions";

import FileSaver from "file-saver";

const Card = asyncRoute(() => import("../../../../components/Card"));
const BreadCrumb = asyncRoute(() =>
  import("../../../../components/BreadCrumb")
);
const Tabs = asyncRoute(() => import("../../../../components/Tabs"));
const ToastModal = asyncRoute(() =>
  import("../../../../components/ToastModal")
);

class Ro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advertiserListData: [],
      submited: false,
      form: {},
      touched: {},
      errors: {},
      roListData: [],
      roListNames: [],
      selectedData: {},
      selectedStatus: {},
      selectedCampaignMap: {},
      selectedRo: [],
      selectedFilterCampaign: [],
      roStatus: [],
      campaignFilterList: [],
      statusData: {},
      roNamesData: {},
      // allRo:{},
      filteredTableData: [],
      confirmationOpen: false,
      confirmationInfo: "",
      roList: [],
      optionsList: optionsData,
      viewMappedCampaign: false,
      mappedCampaignData: [],
      selectedAdvertiser:{},
      advertiserOptionsData:[],
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      isRoStatusClicked: false,
      payloadForRoStatus: {},
      isCampaignDeleteClicked: false,
      paramsForCampaignDelete: {},
      currentIndexForPagination: 1,
    };
  }

  async componentDidMount() {
    // console.log(this.props.tenantId);
    let istenantAgency = isTenantAgency(this.props.tenantId);
    // console.log("isTenantAgency",istenantAgency)
    this.setState({ istenantAgency: istenantAgency });
  }

  async componentWillMount() {
    let isAuthenticated = JSON.parse(localStorage.getItem("AuthData"));

    let optionsList = checkTablePermission(
      { add: PERMISSION.RO.RO.ADD, edit: PERMISSION.RO.RO.EDIT },
      cloneDeep(optionsData)
    );

    // console.log(this.props.tenantId);
    // let istenantAgency = isTenantAgency(this.props.tenantId);
    // console.log("isTenantAgency",istenantAgency)
    // this.setState({ istenantAgency: istenantAgency });

    this.setState({ optionsList });

    const { history } = this.props;
    if (isEmpty(isAuthenticated)) {
      history.push(routes.preSignIn);
    }

    // let selectedRO = {
    //   label: "All",
    //   value: "All RO",
    // };

    this.setState(
      {
        roStatus: roStatus,
        selectedStatus: roStatus[1],
        selectedCampaignMap: mappedStatus[0],
        // selectedRo: selectedRO,
      },
      async () => {
        // await this.getUnmappedCampaignCount();
        await this.listadvFilter();
        await this.listRO();
        await this.listRoNames();
        await this.campaignListNames();
      }
    );
  }

  listadvFilter = async () => {
    const { tenantId, authToken, userId, getCampaignCustomAction, configurationList } = this.props;
    const {istenantAgency} = this.state;
    const {
      responseCode: { status = "" },
      response,
    } = await getCampaignCustomAction({ tenantId, authToken, userId });
    if (status === "Success") {

      const advsData = response.advertisers.map((item, index) => {
        return { label: item.value, value: item.id };
      });

      let filteredSelectedAdvertiser = {};

      if (advsData && advsData.length == 1 && istenantAgency) {
        filteredSelectedAdvertiser = advsData[0];
      }
      else {
        let objForAll = { label: 'All', value: -1 };
        advsData.unshift(cloneDeep(objForAll))
        filteredSelectedAdvertiser = cloneDeep(objForAll)
      }
    
      this.setState({ advertiserOptionsData:advsData,selectedAdvertiser:filteredSelectedAdvertiser });
    } 
  }

  getUnmappedCampaignCount = async () => {
    const { getCountUnMappedCampaignAction, tenantId, authToken, userId } =
      this.props;
    await getCountUnMappedCampaignAction({
      tenantId,
      authToken,
      userId,
    });
  };

  campaignListNames = async () => {
    const { postCampaignRoListAction, tenantId, authToken, userId } =
      this.props;
    const { selectedRo = [] } = this.state;

    let roDataPayload = selectedRo.map((dataRo) => {
      return { id: dataRo.value, value: dataRo.label };
    });

    const payload = {
      ro: roDataPayload,
    };
    let {
      responseCode: { status = "" },
      responseList = [],
    } = await postCampaignRoListAction({
      tenantId,
      authToken,
      userId,
      payload,
    });
    if (status.toLowerCase() == "success") {
      this.setState({ selectedFilterCampaign:[],campaignFilterList: responseList.map((dataList)=>({value:dataList.campaignId,label:dataList.name,roId:dataList.roId}))});
    }
  };

  getIoListAll() {
    const { getIoListAllReportAction, tenantId, authToken, userId } =
      this.props;
  }

  handleAction = (row, action) => {
    const { match, history } = this.props;
    if (action.type === "edit") {
      this.handleEdit(row, match, history);
    } 
    else if (action.type === "view") {
      history.push(`${match.path}/${routes.ro.viewRo}/${row.id}`);
    }
    else if (action.type === "delete") {
      this.handleDelete(row, action);
    } else if (action.key === "status") {
      let payloadStatus = {
        id: row.id,
        status: row.status == 1 ? 0 : 1,
      };
      this.setState({
        enableToast: true,
        toastStatus: "confirmation",
        confirmationMsg: `Are you sure you want to ${
          row.status == 1 ? "inactive" : "active"
        } this record ${row.status == 1 && row.CampaignStatusCnt > 0 ? 
          '( Recommendations for all active campaigns under this goals will be stopped by making goals inactive )':' '}?`,
        isRoStatusClicked: true,
        payloadForRoStatus: payloadStatus,
      });
    } else if (action.type == "goalList") {
      this.downloadGoalList(action);
    }
  };

  downloadGoalList = async (action) => {
    const { downloadRoListAction, tenantId, authToken, userId} = this.props;
    const {selectedCampaignMap,selectedStatus,selectedRo=[],selectedFilterCampaign,selectedAdvertiser } = this.state;

    let advertiserFil = [];
    
    if(selectedAdvertiser && selectedAdvertiser.value != -1){
      advertiserFil.push(selectedAdvertiser.value)
    }

    let dataFilter = {
      advId:advertiserFil,
      roId:selectedRo.map((data)=>data.value),
      campaigns: selectedFilterCampaign.map((dataCamp)=>dataCamp.roId),
      CampaignsMapped: selectedCampaignMap.value,
      status: selectedStatus.value,
    };

    let res = await downloadRoListAction({ tenantId, authToken, userId,payload:dataFilter });
    if (typeof res == "string") {
      let blob = new Blob([res], { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(blob, `${action.saveFileName}.csv`);
    }
  };

  handleStatus = async () => {
    const { tenantId, authToken, userId, roStatusUpdateAction } = this.props;
    const { payloadForRoStatus, filteredTableData } = this.state;

    let clonedFilteredData = cloneDeep(filteredTableData);
    const {
      responseCode: { status = "" },
      responseList,
    } = await roStatusUpdateAction({
      tenantId,
      authToken,
      userId,
      payload: payloadForRoStatus,
    });
    if (status.toLowerCase() == "success") {
      let findIndexRo = clonedFilteredData.findIndex(
        (dataRo) => dataRo.id == payloadForRoStatus.id
      );
      if (findIndexRo >= 0) {
        clonedFilteredData[findIndexRo].status = payloadForRoStatus.status;
        this.setState({ filteredTableData: clonedFilteredData });
      }
    }
  };

  handleEdit(row, match, history) {
    history.push(`${match.path}/${routes.ro.editRo}/${row.id}`);
  }

  async handleDelete(row) {
    const { deleteIoAction, tenantId, authToken, userId } = this.props;
    let response = await deleteIoAction(tenantId, authToken, userId, {
      delio: row.insertionOrderId,
    });
    if (response.status === "Success") {
      this.getIoListAll();
      return;
    }
  }

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({
      confirmationOpen: !confirmationOpen,
      confirmationInfo: confirmation,
    });
  };

  confirmationCallBack = (success, info) => {
    this.setState({ confirmationOpen: false });
  };

  // ============ list RO api ===================
  listRO = async () => {
    const {
      selectedStatus,
      selectedCampaignMap,
      selectedRo=[],
      selectedFilterCampaign=[],
      selectedAdvertiser
    } = this.state;
    const { tenantId, authToken, userId, roListAction } = this.props;
    let advertiserFil = [];
    
    if(selectedAdvertiser && selectedAdvertiser.value != -1){
      advertiserFil.push(selectedAdvertiser.value)
    }
    
    let dataFilter = {
      advId:advertiserFil,
      roId: selectedRo.map((dataRo)=>dataRo.value),
      campaigns: selectedFilterCampaign.map((dataCamp)=>dataCamp.roId),
      CampaignsMapped: selectedCampaignMap.value,
      status: selectedStatus.value,
    };
    const {
      responseCode: { status = "" },
      responseList = [],
    } = await roListAction({
      tenantId,
      authToken,
      userId,
      payload: dataFilter,
    });
    if (status === "Success") {
      let dataRo = responseList.map((dataList) => {
        return {
          ...dataList,
          primaryGoal: dataList.goalValue
            ? dataList.goalValue.primaryGoal
              ? dataList.goalValue.primaryGoal.value
                ? dataList.goalValue.primaryGoal.value
                : ""
              : ""
            : "",
          primaryGoalValue: dataList.goalValue
            ? dataList.goalValue.primaryGoal
              ? dataList.goalValue.primaryGoal.targetValue
                ? dataList.goalValue.primaryGoal.targetValue
                : ""
              : ""
            : "",
        };
      });

      this.setState({ roListData: dataRo,filteredTableData:dataRo});
      this.setState({ roList: responseList });
    }
  };

  listRoNames = async () => {
    const { tenantId, authToken, userId, roListNamesAction } = this.props;
    const { roListData, roStatus } = this.state;
    const {
      responseCode: { status = "" },
      responseList,
    } = await roListNamesAction({ tenantId, authToken, userId });
    if (status === "Success") {
      let roList = responseList.map((item, index) => {
        return { label: item.name, value: item.id, name: "ro" };
      });

      roList.sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      // let obj = {
      //   label: "All",
      //   value: "All RO",
      //   name: "ro",
      // };
      // roList.unshift(obj);
      this.setState({ roListNames: roList });

      // const inititalList = obj;
      // const inititalStatus = roStatus[0];

      // this.setState({ filteredTableData: roListData });
      // this.setState({ roNamesData: inititalList });
    }
  };

  handleRoChange = async (selected, type = "") => {
    const { selectedCampaignMap } = this.state;
    this.setState({ selectedData: selected });

    if (type == "ro") {
      this.setState({ selectedRo: selected }, async () => {
        await this.campaignListNames();
      });
    } else if (type == "mapStatus") {
      let clonedFilterData = cloneDeep(selectedCampaignMap);
      console.log(clonedFilterData)
      if(clonedFilterData.value == 0) {
        await this.campaignListNames();
      }
      if (selected.value == 0) {
        this.setState({ selectedFilterCampaign: [] });
      } 
      this.setState({ selectedCampaignMap: selected });
    } else if (type == "campaignFilter") {
      this.setState({ selectedFilterCampaign: selected });
    } 
    else if (type == "advertiser") {
      this.setState({ selectedAdvertiser: selected });
    }
    else {
      this.setState({ selectedStatus: selected });
    }
  };

  handleApply = (e) => {
    e.preventDefault();
    const {
      roNamesData,
      statusData,
      roListData,
      roList,
      allRo,
      selectedRo,
      selectedStatus,
    } = this.state;

    this.setState({currentIndexForPagination:1},()=>{
    this.listRO();

    })
    // const newData = roListData.filter((roData) => {
    //   return roData.name === roNamesData.value && roData.status === statusData;
    // });

    // this.setState({ filteredTableData: newData });

    // if (roNamesData.value === "All RO") {
    //   const newData = roListData.filter((roData) => {
    //     return roData.status === statusData;
    //   });

    //   this.setState({ filteredTableData: newData });
    // }

    // if (statusData === 2) {
    //   this.setState({ filteredTableData: roListData });
    // }

    // if (statusData === 2 && roNamesData.value != "All RO") {
    //   const filterNewRo = roListData.filter((roData) => {
    //     return roData.name === roNamesData.value;
    //   });
    //   this.setState({ filteredTableData: filterNewRo });
    // }
  };

  handleReset = async (e) => {
    e.preventDefault();
    this.setState(
      {
        selectedRo: [],
        selectedStatus: roStatus[1],
        selectedCampaignMap: mappedStatus[0],
        selectedFilterCampaign: [],
        currentIndexForPagination:1
      },
      () => {
        this.listRO();
      }
    );
  };

  fetchMappedCampaign = async (roID) => {
    const { campaignMappedRoAction, tenantId, authToken, userId } = this.props;

    const {
      responseCode: { status = "" },
      responseList = [],
    } = await campaignMappedRoAction({ tenantId, authToken, userId, roID });

    if (status.toLowerCase() == "success") {
      let roIdInsertData = responseList.map((data) => {
        return { ...data, campRoId: roID };
      });
      this.setState({
        mappedCampaignData: roIdInsertData || [],
        viewMappedCampaign: true,
      });
    }
  };

  handleActionMappedCampaign = (row, action) => {
    if (action.type == "edit") {
      let params = {
        roId: row.campRoId,
        campId: row.campaignId,
      };
      this.setState({
        isCampaignDeleteClicked: true,
        paramsForCampaignDelete: params,
        enableToast: true,
        toastStatus: "confirmation",
        confirmationMsg: `Are you sure you want to unmap this campaign?`,
      });
    }
  };

  deleteMappedCampaign = async () => {
    const { deleleMappedWithCampaignAction, tenantId, authToken, userId } =
      this.props;
    const { mappedCampaignData, filteredTableData, paramsForCampaignDelete } =
      this.state;

    let {
      responseCode: { status = "",msg="" },
    } = await deleleMappedWithCampaignAction({
      tenantId,
      authToken,
      userId,
      params: paramsForCampaignDelete,
    });
    if (status.toLowerCase() == "success") {
      let clonedFilteredList = cloneDeep(mappedCampaignData);
      let clonedDataList = cloneDeep(filteredTableData);

      clonedFilteredList = clonedFilteredList.filter(
        (dataMap) => dataMap.campaignId != paramsForCampaignDelete.campId
      );

      let findIndex = clonedDataList.findIndex(
        (dataList) => dataList.id == paramsForCampaignDelete.roId
      );

      if (findIndex >= 0) {
        clonedDataList[findIndex].MappedCampCount =
          clonedDataList[findIndex].MappedCampCount - 1;
      }
       this.setState({
        mappedCampaignData: clonedFilteredList,
        filteredTableData: clonedDataList,
        paramsForCampaignDelete: {},
        enableToast:true,
        toastStatus:status,
        toastMsg:msg
      });
    }
  };

  confirmationCallbackModel = (id) => {
    const { isRoStatusClicked, isCampaignDeleteClicked } = this.state;
    this.setState({ enableToast: false }, () => {
      if (isRoStatusClicked) {
        this.setState({ isRoStatusClicked: false });
        this.handleStatus();
      }
      if (isCampaignDeleteClicked) {
        this.setState({ isCampaignDeleteClicked: false });
        this.deleteMappedCampaign();
      }
    });
  };

  handleToastStatus = (status) => {
    this.setState({ enableToast: status }, () => {});
  };

  setCurrentPageIndexForPagination = (page) => {
    this.setState({ currentIndexForPagination: page });
  };

  render() {
    const { match, ioListAll, configurationList } = this.props;
    const {
      confirmationOpen,
      confirmationInfo,
      optionsList,
      filteredTableData,
      campaignFilterList,
      selectedFilterCampaign,
      submited,
      touched,
      errors,
      form,
      roListData,
      roListNames,
      selectedData,
      selectedCampaignMap,
      roStatus,
      selectedStatus,
      selectedRo,
      istenantAgency,
      viewMappedCampaign,
      mappedCampaignData = [],
      selectedAdvertiser,
      advertiserOptionsData,
      enableToast = false,
      toastStatus = "",
      toastMsg = "",
      confirmationMsg = "",
      currentIndexForPagination,
    } = this.state;

    
    const inititalList = roListNames[0] != undefined ? roListNames[0] : "";
    const inititalStatus = roStatus[0] != undefined ? roStatus[0] : "";
    const customStyles = {
      placeholder: (defaultStyles) => {
        return {
          ...defaultStyles,
          color: "hsl(0, 0%, 20%);",
        };
      },
    };

    let clonedOptionList = cloneDeep(optionsList);

    clonedOptionList.columns.forEach((element, index) => {
      if (element.name == "MappedCampCount") {
        clonedOptionList.columns[index].component = (row) =>
          row.MappedCampCount > 0 ? (
            <a
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "#5d80ff",
              }}
              onClick={() => {
                this.fetchMappedCampaign(row.id);
              }}
            >
              {row.MappedCampCount ? row.MappedCampCount : 0}
            </a>
          ) : (
            <a style={{ color: "#5d80ff" }}>
              {row.MappedCampCount ? row.MappedCampCount : 0}
            </a>
          );
      }
    });

    return (
      <>
        {confirmationOpen && (
          <ModalConfirmation
            open={confirmationOpen}
            onClose={this.toggleModal}
            confirmationInfo={confirmationInfo}
            handelConfirmationMessage={this.confirmationCallBack}
          />
        )}
        {enableToast && (
          <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            // path={routes.containers.admin + "/" + routes.admin.advertiser.poc}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            outSideClickEnable={false}
            poc={true}
          />
        )}
        <Modal open={viewMappedCampaign} size="large">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Mapped Campaigns</h5>
              <button
                type="button"
                onClick={() =>
                  this.setState({ viewMappedCampaign: !viewMappedCampaign })
                }
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <div className="modal-title modal-colse modal-cross">
                  <span aria-hidden="true">×</span>
                </div>
              </button>
            </div>

            <div className="modal-body table-responsive inputUI">
              <Table
                options={mappedCampaignOptions}
                data={mappedCampaignData}
                handelAction={this.handleActionMappedCampaign}
              />
            </div>
          </div>
        </Modal>
        <div className="main-panel ion">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row mt-3 parentDiv">
              <Card>
                <Tabs container="goals" />
                {checkAddPermission(PERMISSION.RO.RO.ADD) &&
                  !istenantAgency && (
                    <div className="margin-list-adj">
                      <Link to={`${match.path}/${routes.ro.addRo}`}>
                        {" "}
                        <button className="btn btn-primary">
                          <i className="mdi mdi-plus"></i>Goals
                        </button>
                      </Link>
                    </div>
                  )}

                <div class="accordion mt-4" id="accordionWithIcon">
                  <div class="accordion-item card">
                    <h2 class="accordion-header d-flex align-items-center">
                      <button
                        type="button"
                        class="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionWithIcon-2"
                        aria-expanded="true"
                      >
                        <i class="me-2 ti ti-filter ti-xs"></i>
                        Filter Goals
                      </button>
                    </h2>
                    <div
                      id="accordionWithIcon-2"
                      class="accordion-collapse collapse show"
                    >
                      <div class="accordion-body pb-3">
                        {/* <div className="row">
                                    <div className="col-md-12 grid-margin mb-0"> */}
                        <div className="row">
                          <div className="col-md-12 px-0  ">
                            <form
                              className="form-inline d-flex align-items-center"
                              id="filterform"
                              style={{
                                display: "block",
                                "border-radius": "5px",
                              }}
                            >
                              {
                                istenantAgency &&
                                <div className='col-md-4'>
                                  <lable className="mr-2">Advertiser:</lable>
                                  <Select
                                    options={advertiserOptionsData}
                                    isMulti={false}
                                    placeholder="All"
                                    defaultValue={selectedAdvertiser}
                                    value={selectedAdvertiser}
                                    onChange={(selected) => this.handleRoChange(selected, "advertiser")}
                                    className="campaignFilter"
                                  />
                                </div>
                              }
                              <div className="col-md-4">
                                <lable className="mr-2">Goals:</lable>
                                <div className="roSelectDiv">
                                  <Select
                                    options={roListNames}
                                    // defaultValue={selectedRo}
                                    value={selectedRo}
                                    onChange={(selected) =>
                                      this.handleRoChange(selected, "ro")
                                    }
                                    className="roFilter"
                                    isMulti={true}
                                    placeholder="All"
                                    styles={customStyles}
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <lable className="mr-2">
                                  Campaigns Mapped:
                                </lable>
                                <div className="roSelectDiv">
                                  <Select
                                    options={mappedStatus}
                                    defaultValue={selectedCampaignMap}
                                    value={selectedCampaignMap}
                                    onChange={(selected) =>
                                      this.handleRoChange(selected, "mapStatus")
                                    }
                                    className="roFilter"
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <lable className="mr-2">Campaigns:</lable>
                                <div className="roSelectDiv">
                                  <Select
                                    options={campaignFilterList}
                                    defaultValue={selectedFilterCampaign}
                                    value={selectedFilterCampaign}
                                    onChange={(selected) =>
                                      this.handleRoChange(
                                        selected,
                                        "campaignFilter"
                                      )
                                    }
                                    className="roFilter"
                                    isMulti={true}
                                    placeholder={
                                      selectedCampaignMap.value == 0
                                        ? ""
                                        : "All"
                                    }
                                    styles={customStyles}
                                    isDisabled={
                                      selectedCampaignMap.value == 0
                                        ? true
                                        : false
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-4 mt-2">
                                <lable className="mr-2">Status:</lable>
                                <div className="roSelectDiv">
                                  <Select
                                    options={roStatus}
                                    defaultValue={selectedStatus}
                                    value={selectedStatus}
                                    onChange={(selected) =>
                                      this.handleRoChange(selected)
                                    }
                                    className="roFilter"
                                  />
                                </div>
                              </div>
                              <div className={`${ istenantAgency ? 'col-md-4' :'col-md-8'} d-flex justify-content-between justify-content-md-end mt-4`}>
                                <button
                                  onClick={(e) => this.handleApply(e)}
                                  className="btn btn-primary"
                                >
                                  <i className="mdi mdi-account-check"></i>Apply
                                </button>
                                <button
                                  onClick={(e) => this.handleReset(e)}
                                  className="btn btn-primary ml-3"
                                >
                                  <i class="mdi mdi-replay"></i>Reset
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                        {/* </div>
                                </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="row">
                                    <div className="col-md-12 grid-margin mb-0">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <form className="form-inline d-flex align-items-center" id="filterform" style={{ display: 'block', "border-radius": '5px' }}>
                                                    <div className='col-md-3'>
                                                        <lable className="mr-2">RO:</lable>
                                                        <div className='roSelectDiv'>
                                                            <Select
                                                                options={roListNames}
                                                                defaultValue={selectedRo}
                                                                value={selectedRo}
                                                                onChange={(selected) => this.handleRoChange(selected)}
                                                                className="roFilter"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <lable className="mr-2">Status:</lable>
                                                        <div className='roSelectDiv'>
                                                            <Select
                                                                options={roStatus}
                                                                defaultValue={selectedStatus}
                                                                value={selectedStatus}
                                                                onChange={(selected) => this.handleRoChange(selected)}
                                                                className="roFilter"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6 d-flex justify-content-between justify-content-md-start mt-4">
                                                        <button onClick={(e) => this.handleApply(e)} className="btn btn-primary"><i className='mdi mdi-account-check'></i>Apply</button>
                                                        <button onClick={(e) => this.handleReset(e)} className="btn btn-primary ml-3"><i class="mdi mdi-replay"></i>Reset</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                {/* </Card>

                            <Card> */}
                <div className="table-responsive mt-2">
                  <Table
                    options={clonedOptionList}
                    data={filteredTableData}
                    handelAction={this.handleAction}
                    hideActionColumn={istenantAgency}
                    currentIndex={currentIndexForPagination}
                    setCurrentPageIndexForPagination={
                      this.setCurrentPageIndexForPagination
                    }
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      getUserPermissionList: get(state, "app.getUserPermissionList", []),
      configurationList: get(state, "app.configurationData.responseList", []),
      ioListAll: get(state, "app.ioListAllReport.responseList", []),
      tenantId: get(state, "app.preSignInState.tenantId", ""),
      userId: get(state, "app.preSignInData.userId", ""),
      authToken: get(state, "app.signInData.authToken", ""),
    }),
    {
      getIoListAllReportAction,
      deleteIoAction,
      getIoEditIdReportAction,
      addIoReportAction,
      roListAction,
      roListNamesAction,
      campaignMappedRoAction,
      downloadRoListAction,
      roStatusUpdateAction,
      deleleMappedWithCampaignAction,
      getCountUnMappedCampaignAction,
      postCampaignRoListAction,
      getCampaignCustomAction
    }
  )(Ro)
);

// ----*  IO propTypes * ----
Ro.propTypes = {
  configurationList: PropTypes.array,
  ioListAll: PropTypes.array,
  tenantId: PropTypes.number,
  userId: PropTypes.number,
  authToken: PropTypes.string,
  getIoListAllReportAction: PropTypes.func,
  deleteIoAction: PropTypes.func,
};
